
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[[...category]]",
      function () {
        return require("private-next-pages/search/[[...category]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[[...category]]"])
      });
    }
  